import React, { useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "./_redux/Actions";
// import { FieldFeedbackLabel } from "../../../_metronic/_partials/controls/forms/FieldFeedbackLabel";
import { Field } from "formik";
import { imageUrl } from "../UIHelpers";
// const getFieldCSSClasses = (touched, errors) => {
//     const classes = ["form-control", "form-control-solid"];
//     if (touched && errors) {
//         classes.push("is-invalid-select");
//     }

//     if (touched && !errors) {
//         classes.push("is-valid-select");
//     }

//     return classes.join(" ");
// };

const GameSelectInput = ({
    field, // { name, value, onChange, onBlur }
    form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    label,
    withFeedbackLabel = true,
    customFeedbackLabel,
    children,
    filter,
    disabled,
    ...props
}) => {

    const dispatch = useDispatch();
    useEffect(() => {
        console.log(props.source, 'props.source');
        if(props.source === 'gameType') {
            dispatch(actions.getGameTypeList({ source: props.source, filter: filter }));
        } else {
            dispatch(actions.getGameList({ source: props.source, filter: filter }));
        }
        
    }, [props.source, filter]);

    const { currentState } = useSelector(
        (state) => ({ currentState: state.searchList }),
        shallowEqual
    );

    const onChangeHandle = (value) => {
        if(props.onSelect) {
            const item = searchData[props.source].find(item => item._id === value);
            console.log(gameData, '--------------------');
            props.onSelect(item, gameData);
        }
    };

    const { searchData, gameData } = currentState

    return (
        <>
            {label && <h4 className="col-md-12">Select {label}</h4>}
            {
                props.source==="game" ? 
                (searchData && searchData[props.source]  && searchData[props.source].length>0 ? (searchData[props.source].map((item, index) =>
                <div className="col-md-4 col-6  mb-6 pl-0" key={`select${searchData[props.source]}${index}`}>
                    <label>
                    <div className={field.value === item._id ? 'card card-custom overlay active' : 'card card-custom overlay'}>
                        <div className="card-body p-0">
                            <div className="overlay-wrapper">
                                {console.log("imageUrl", imageUrl)}
                                <img src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${item && item.featuredImage && item.featuredImage.default}`}
                                    className="max-h-100px min-h-100px ob-fit-cover w-150px rounded" alt="game-images" />
                            </div>
                            <div className="overlay-layer-dark m-0 text-center rounded flex-center">
                                <div key={item._id} className="text-light font-weight-bolder font-size-h5 font-size-h6-lg pt-lg-1 pb-lg-1 pt-8 pb-4">{item.name}</div>
                            </div>
                            <Field onClick={(e)=>onChangeHandle(e.target.value)} type="radio" disabled={disabled} className="hide" name={field.name} value={item._id} />
                        </div>
                    </div>
                    </label>
                </div>
            )) : "There is no common games in selected companies.")
                 : (searchData && searchData[props.source] && searchData[props.source].map((item, index) =>
                 <div className="col-md-4  mb-6" key={`select${searchData[props.source]}${index}`}>
                     <label>
                     <div className={field.value === item._id ? 'card card-custom overlay active' : 'card card-custom overlay'}>
                         <div className="card-body p-0">
                             <div className="overlay-wrapper">
                                 <img src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${item && item.featuredImage && item.featuredImage.default}`}
                                     className="max-h-100px min-h-100px ob-fit-cover w-150px rounded" alt="game-images" />
                             </div>
                             <div className="overlay-layer-dark m-0 text-center rounded flex-center">
                                 <div key={item._id} className="text-light font-weight-bolder font-size-h5 font-size-h6-lg pt-lg-1 pb-lg-1 pt-8 pb-4">{item.name}</div>
                             </div>
                             <Field onClick={(e)=>onChangeHandle(e.target.value)} type="radio" disabled={disabled} className="hide" name={field.name} value={item._id} />
                         </div>
                     </div>
                     </label>
                 </div>
             ))
                
            }
        </>
    );
}
export default GameSelectInput;